  import { CalendarOutlined, TrophyOutlined } from "@ant-design/icons";
  import { DatePicker } from "antd";
  import axios from "axios";
  import dayjs from "dayjs";
  import { useEffect, useState } from "react";
  import { CREATE_jwel } from "../../../Config/Config";
  import styles from "../shared/Inventory.module.css";
  import InventoryPageHeader from "../shared/InventoryPageHeader";
  import InventoryTable from "../shared/InventoryTable";
  import PdfExcelPrint from "../../Utiles/PdfExcelPrint";

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNo",
      key: "serialNo",
      width: 60,
      align: "center",
      className: "col-sno",
    },
    {
      title: "Company Name",
      dataIndex: "COMPNAME",
      key: "COMPNAME",
      className: "col-productname",
    },
    {
      title: "Qty",
      dataIndex: "QTY",
      key: "QTY",
      align: "center",
      className: "col-pieces",
      render: (v) => <span className="piecesBadge">{v || 0}</span>,
    },
    {
      title: "Amount",
      dataIndex: "AMOUNT",
      key: "AMOUNT",
      align: "right",
      className: "col-netwt",
      render: (v) => <span className="wtBadge">{v}</span>,
    },
  ];

  const primaryFields = [
    { key: "COMPNAME", label: "Company" },
    { key: "QTY", label: "Qty", badge: "pieces" },
    { key: "AMOUNT", label: "Amount", badge: "netwt" },
  ];
  const secondaryFields = [];

  const TopTenBrands = () => {
    const tenantName = localStorage.getItem("tenantName");
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [tableData, setTableData] = useState([]);
    const [tableVisible, setTableVisible] = useState(false);

    useEffect(() => {
      if (!startDate || !endDate) return;

      const fromDate = startDate.format("YYYY-MM-DD");
      const toDate = endDate.format("YYYY-MM-DD");

      setTableVisible(false);

      axios
        .get(
          `${CREATE_jwel}/api/ERP/GetTopTenBrands?billStartDate=${fromDate}&billEndDate=${toDate}`,
          { headers: { tenantName } },
        )
        .then((response) => {
          const detailsData = response.data || [];
          const calculatedData = detailsData.map((item, index) => ({
            ...item,
            key: index + 1,
          }));
          const lastTen = calculatedData.slice(-10);

          const rows = lastTen.map((item, index) => ({
            ...item,
            serialNo: index + 1,
            AMOUNT: Number(item.AMOUNT || 0).toFixed(2),
            QTY: item?.QTY ?? 0,
          }));

          setTableData(rows);
          setTimeout(() => setTableVisible(true), 80);
        })
        .catch((error) => {
          console.error("Error fetching top 10 brands:", error);
        });
    }, [startDate, endDate]);

    const totalQty = tableData.reduce((s, r) => s + Number(r.QTY || 0), 0);
    const totalAmt = tableData.reduce((s, r) => s + Number(r.AMOUNT || 0), 0);

    const exportData = [
      ...tableData,
      {
        serialNo: "Total",
        COMPNAME: "",
        QTY: totalQty,
        AMOUNT: totalAmt.toFixed(2),
      },
    ];

    return (
      <div className={styles.page}>
        <InventoryPageHeader
          title="Top 10 Brands"
          subtitle="Reports · Sales"
          icon={<TrophyOutlined style={{ color: "#fff", fontSize: 16 }} />}
          recordCount={tableData.length}
          visible={tableData.length > 0}
          stats={[
            { label: "Records", value: tableData.length, color: "blue" },
            { label: "Qty", value: totalQty, color: "orange" },
            { label: "Total Amt", value: totalAmt.toFixed(2), color: "green" },
          ]}
        />

        <div className={styles.toolbar}>
          <div className={styles.toolbarLeft}>
            <div className="mainProductHighlight">
              <span className="mainProductIcon">
                <CalendarOutlined />
              </span>
              <div className="mainProductInner">
                <div className={styles.toolbarLabel}>Start Date</div>
                <DatePicker
                  className="mainProductPicker"
                  style={{ width: "100%" }}
                  size="middle"
                  value={startDate}
                  onChange={(d) => setStartDate(d || dayjs())}
                  format="DD/MM/YYYY"
                  allowClear={false}
                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                />
              </div>
            </div>

            <div className="mainProductHighlight">
              <span className="mainProductIcon">
                <CalendarOutlined />
              </span>
              <div className="mainProductInner">
                <div className={styles.toolbarLabel}>End Date</div>
                <DatePicker
                  className="mainProductPicker"
                  style={{ width: "100%" }}
                  size="middle"
                  value={endDate}
                  onChange={(d) => setEndDate(d || dayjs())}
                  format="DD/MM/YYYY"
                  allowClear={false}
                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                />
              </div>
            </div>
          </div>
          <div className={styles.toolbarRight}>
            <PdfExcelPrint
              data={exportData}
              columns={columns}
              fileName="TopTenBrands"
              disabled={tableData.length === 0}
            />
          </div>
        </div>

        <InventoryTable
          columns={columns}
          dataSource={tableData}
          rowKey="key"
          tableClassName="mr-table"
          tableEnter={tableVisible}
          emptyText="No brands found for the selected date range"
          primaryFields={primaryFields}
          secondaryFields={secondaryFields}
        />
        <style>{`
    @keyframes mainProductPulse {
      0%   { box-shadow: 0 0 0 0 rgba(24,144,255,0.30); }
      70%  { box-shadow: 0 0 0 8px rgba(24,144,255,0); }
      100% { box-shadow: 0 0 0 0 rgba(24,144,255,0); }
    }
    .mainProductHighlight {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 18px 8px 10px;
      border-radius: 14px;
      background: #eef6ff;
      border: 1.5px solid #65aefd;
      box-shadow: 0 0 0 1.5px #bcdcff inset;
      animation: mainProductPulse 2.4s infinite;
      min-width: 210px;
      flex-shrink: 0;
    }
    .mainProductIcon {
      width: 34px;
      height: 34px;
      border-radius: 9px;
      background: #ffffff;
      box-shadow: 0 1px 3px rgba(24,144,255,0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #1677ff;
      flex-shrink: 0;
    }
    .mainProductInner {
      display: flex;
      flex-direction: column;
      gap: 3px;
      flex: 1;
      min-width: 0;
    }
    .mainProductPicker.ant-picker {
      height: 34px !important;
      border-radius: 8px !important;
      background: #ffffff !important;
      border: 1px solid #d6e8ff !important;
      width: 100%;
    }
    .mainProductPicker.ant-picker-focused {
      border-color: #1890ff !important;
      box-shadow: none !important;
    }
    .mainProductPicker .ant-picker-input > input {
      font-size: 13px;
    }
  `}</style>
      </div>
    );
  };

  export default TopTenBrands;